// removed by extract-text-webpack-plugin
module.exports = {"social":"u8AiHiCAZSoyUR-HUAZUg","social-head":"_6YT-69wxVKrB-P6JkAdgQ","inner":"H-Q0h26TX22PRWxBFVBvy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/ShareSocialsModal.scss
// module id = 1242
// module chunks = 0